(function () {
  var sections = document.querySelectorAll('.oddit-section-product-main');
  if (!sections.length) return;

  sections.forEach(initSection);

  function initSection(section) {
    var data = readProductData(section);
    initThumbnails(section);
    initSizePicker(section, data);
    initBundleTiers(section, data);
    initAddToCart(section);
    initPairedUpsell(section);
  }

  // Lazy-loads recommendation-driven cards (related / complementary) for the
  // "paired_upsell" block. Custom-collection sources are rendered server-side
  // and skipped here.
  function initPairedUpsell(section) {
    var blocks = section.querySelectorAll('[data-paired-upsell]');
    blocks.forEach(function (el) {
      var source = el.getAttribute('data-source');
      if (source !== 'related' && source !== 'complementary') return;

      var handle = el.getAttribute('data-product-handle');
      var productId = el.getAttribute('data-product-id');
      var limit = el.getAttribute('data-limit') || '4';
      var listEl = el.querySelector('[data-paired-upsell-list]');
      if (!handle || !listEl) return;

      var url =
        '/products/' + encodeURIComponent(handle) + '/recommendations' +
        '?section_id=oddit-paired-upsell-cards' +
        '&product_id=' + encodeURIComponent(productId) +
        '&intent=' + encodeURIComponent(source) +
        '&limit=' + encodeURIComponent(limit);

      fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('paired upsell fetch failed: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('.oddit-section-product-main__paired-upsell-card');
          if (!cards.length) return;
          listEl.innerHTML = '';
          cards.forEach(function (card) { listEl.appendChild(card); });
          el.removeAttribute('hidden');
        })
        .catch(function () { /* keep hidden */ });
    });
  }

  function readProductData(section) {
    var el = section.querySelector('[data-product-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getCurrentVariantId(section) {
    var btn = section.querySelector('[data-add-to-cart]');
    if (!btn) return null;
    var id = btn.getAttribute('data-variant-id');
    return id ? Number(id) : null;
  }

  function findVariant(variants, options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options.length !== options.length) continue;
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (v.options[j] !== options[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function findVariantById(variants, id) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return null;
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function applyVariant(section, data, variant) {
    if (!variant) return;

    var galleryImg = section.querySelector('.oddit-section-product-main__gallery-image');
    if (galleryImg && variant.gallery) {
      galleryImg.src = variant.gallery.src;
      if (variant.gallery.srcset) {
        galleryImg.srcset = variant.gallery.srcset;
      } else {
        galleryImg.removeAttribute('srcset');
      }
      if (variant.gallery.alt) galleryImg.alt = variant.gallery.alt;
    }

    var priceEl = section.querySelector('[data-product-price]');
    if (priceEl) priceEl.textContent = variant.price;

    var compareEl = section.querySelector('[data-product-compare-price]');
    if (compareEl) {
      if (variant.compare_at_price) {
        compareEl.textContent = variant.compare_at_price;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    var saveBadge = section.querySelector('[data-product-save-badge]');
    if (saveBadge) saveBadge.hidden = !variant.compare_at_price;

    var addBtn = section.querySelector('[data-add-to-cart]');
    if (addBtn) {
      addBtn.setAttribute('data-variant-id', variant.id);
      addBtn.setAttribute('data-quantity', Number(variant.bundle_quantity) || 1);
      var giftId = variant.free_gift && variant.free_gift.variant_id;
      if (giftId) {
        addBtn.setAttribute('data-gift-variant-id', giftId);
      } else {
        addBtn.removeAttribute('data-gift-variant-id');
      }
      addBtn.disabled = !variant.available;
    }

    var bundleLabel = section.querySelector('[data-bundle-selected-label]');
    if (bundleLabel && variant.tier && variant.tier.title) {
      bundleLabel.textContent = variant.tier.title;
    }

    if (data && data.bundle_option_index >= 0 && variant.options) {
      variant.options.forEach(function (val, i) {
        if (i === data.bundle_option_index) return;
        var pos = i + 1;
        var labelValue = section.querySelector('[data-option-selected-value="' + pos + '"]');
        if (labelValue) labelValue.textContent = (val || '').toUpperCase();

        var sizeButtons = section.querySelectorAll(
          '.oddit-section-product-main__size-option[data-option-position="' + pos + '"]'
        );
        sizeButtons.forEach(function (btn) {
          if (btn.getAttribute('data-option-value') === val) {
            btn.classList.add('oddit-section-product-main__size-option--active');
            btn.setAttribute('aria-checked', 'true');
          } else {
            btn.classList.remove('oddit-section-product-main__size-option--active');
            btn.setAttribute('aria-checked', 'false');
          }
        });
      });
    }

    var tiles = section.querySelectorAll('.oddit-section-product-main__tier');
    tiles.forEach(function (tile) {
      var tileVariantId = Number(tile.getAttribute('data-variant-id'));
      if (tileVariantId === variant.id) {
        tile.classList.add('oddit-section-product-main__tier--active');
        tile.setAttribute('aria-checked', 'true');
      } else {
        tile.classList.remove('oddit-section-product-main__tier--active');
        tile.setAttribute('aria-checked', 'false');
      }
    });

    if (window.history && window.history.replaceState) {
      var loc = new URL(window.location.href);
      loc.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', loc);
    }
  }

  function renderTile(variant, isActive) {
    var classes = 'oddit-section-product-main__tier';
    if (isActive) classes += ' oddit-section-product-main__tier--active';

    var html = '<div class="' + classes + '" role="radio" tabindex="0"' +
      ' aria-checked="' + (isActive ? 'true' : 'false') + '"' +
      ' data-bundle-tier' +
      ' data-variant-id="' + variant.id + '"' +
      ' data-bundle-label="' + escapeHtml(variant.tier && variant.tier.title) + '">';

    if (variant.tier && variant.tier.flag_label) {
      var flagClass = 'oddit-section-product-main__tier-flag';
      if (variant.tier.flag_color === 'blue') flagClass += ' oddit-section-product-main__tier-flag--blue';
      else if (variant.tier.flag_color === 'green') flagClass += ' oddit-section-product-main__tier-flag--green';
      html += '<span class="' + flagClass + '">' + escapeHtml(variant.tier.flag_label) + '</span>';
    }

    html += '<div class="oddit-section-product-main__tier-body">';

    if (variant.tier_image && variant.tier_image.src) {
      html += '<img class="oddit-section-product-main__tier-image"' +
        ' src="' + variant.tier_image.src + '"' +
        (variant.tier_image.srcset ? ' srcset="' + variant.tier_image.srcset + '" sizes="56px"' : '') +
        ' alt="' + escapeHtml(variant.tier_image.alt) + '"' +
        ' loading="lazy">';
    }

    html += '<div class="oddit-section-product-main__tier-info">' +
      '<span class="oddit-section-product-main__tier-title">' + escapeHtml(variant.tier && variant.tier.title) + '</span>';

    if (variant.save_percent > 0) {
      html += '<span class="oddit-section-product-main__tier-save">Save ' + variant.save_percent + '%</span>';
    }

    if (variant.tier && variant.tier.subtitle) {
      html += '<span class="oddit-section-product-main__tier-subtitle">' + escapeHtml(variant.tier.subtitle) + '</span>';
    }

    html += '</div>';

    html += '<div class="oddit-section-product-main__tier-pricing">' +
      '<div class="oddit-section-product-main__tier-prices">' +
      '<span class="oddit-section-product-main__tier-current">' + escapeHtml(variant.price) + '</span>';
    if (variant.compare_at_price) {
      html += '<span class="oddit-section-product-main__tier-compare">' + escapeHtml(variant.compare_at_price) + '</span>';
    }
    html += '</div></div>';

    html += '</div>';

    if (variant.free_gift) {
      html += '<div class="oddit-section-product-main__tier-gift">' +
        '<div class="oddit-section-product-main__tier-gift-content">';
      if (variant.free_gift.image_src) {
        html += '<img class="oddit-section-product-main__gift-image"' +
          ' src="' + variant.free_gift.image_src + '"' +
          ' alt="' + escapeHtml(variant.free_gift.image_alt) + '"' +
          ' loading="lazy">';
      }
      html += '<span class="oddit-section-product-main__gift-title">+ FREE ' + escapeHtml(variant.free_gift.short_name) + '</span>' +
        '</div>' +
        '<div class="oddit-section-product-main__gift-prices">' +
        '<span class="oddit-section-product-main__gift-price">' + escapeHtml(variant.free_gift.price) + '</span>';
      if (variant.free_gift.compare_at_price) {
        html += '<span class="oddit-section-product-main__gift-compare">' + escapeHtml(variant.free_gift.compare_at_price) + '</span>';
      }
      html += '</div></div>';
    }

    html += '</div>';
    return html;
  }

  function rerenderTiles(section, data, currentVariant) {
    var tilesContainer = section.querySelector('.oddit-section-product-main__bundle-tiers');
    if (!tilesContainer || !data || data.bundle_option_index < 0) return;

    var bundleIdx = data.bundle_option_index;
    var packValues = (data.bundle_values && data.bundle_values.length) ? data.bundle_values : null;
    if (!packValues) {
      packValues = [];
      data.variants.forEach(function (v) {
        var val = v.options[bundleIdx];
        if (packValues.indexOf(val) === -1) packValues.push(val);
      });
    }

    var html = '';
    packValues.forEach(function (packValue) {
      var newOptions = currentVariant.options.slice();
      newOptions[bundleIdx] = packValue;
      var match = findVariant(data.variants, newOptions);
      if (match) html += renderTile(match, match.id === currentVariant.id);
    });

    tilesContainer.innerHTML = html;
    bindTileClicks(section, data);
  }

  function bindTileClicks(section, data) {
    var tiles = section.querySelectorAll('.oddit-section-product-main__tier');
    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        var id = Number(tile.getAttribute('data-variant-id'));
        var variant = findVariantById(data.variants, id);
        if (variant) applyVariant(section, data, variant);
      });
      tile.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          tile.click();
        }
      });
    });
  }

  function initThumbnails(section) {
    var thumbnails = section.querySelectorAll('.oddit-section-product-main__thumbnail');
    var mainImg = section.querySelector('.oddit-section-product-main__gallery-image');
    var galleryWrap = section.querySelector('[data-product-gallery-main]');
    var slides = section.querySelectorAll('.oddit-section-product-main__gallery-slide');
    var thumbsContainer = section.querySelector('[data-product-thumbnails]');
    var nextBtn = section.querySelector('[data-thumbnails-next]');
    if (!thumbnails.length || !mainImg) return;

    var mobileQuery = window.matchMedia('(max-width: 989px)');

    function setActive(index) {
      thumbnails.forEach(function (t, i) {
        t.classList.toggle('oddit-section-product-main__thumbnail--active', i === index);
      });
    }

    function activate(thumb, opts) {
      var index = Array.prototype.indexOf.call(thumbnails, thumb);
      setActive(index);

      // Mobile carousel: scroll the corresponding slide into view.
      if (slides.length > 1 && mobileQuery.matches) {
        var slide = slides[index];
        if (slide && slide.scrollIntoView) {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      } else {
        // Desktop: swap the visible image to the thumbnail's media.
        var newSrc = thumb.getAttribute('data-media-src');
        var newSrcset = thumb.getAttribute('data-media-srcset');
        var newAlt = thumb.getAttribute('data-media-alt');
        if (newSrc) {
          mainImg.src = newSrc;
          if (newSrcset) {
            mainImg.srcset = newSrcset;
          } else {
            mainImg.removeAttribute('srcset');
          }
          if (newAlt) mainImg.alt = newAlt;
        }
      }

      if (thumbsContainer && thumb.scrollIntoView && !(opts && opts.silent)) {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activate(thumb);
      });
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var activeIndex = -1;
        thumbnails.forEach(function (t, i) {
          if (t.classList.contains('oddit-section-product-main__thumbnail--active')) activeIndex = i;
        });
        var nextIndex = (activeIndex + 1) % thumbnails.length;
        activate(thumbnails[nextIndex]);
      });
    }

    // Sync the active thumbnail with the carousel position on mobile swipe/scroll.
    if (galleryWrap && slides.length > 1) {
      var scrollTimer;
      galleryWrap.addEventListener('scroll', function () {
        if (!mobileQuery.matches) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var wrapRect = galleryWrap.getBoundingClientRect();
          var center = wrapRect.left + wrapRect.width / 2;
          var closest = -1;
          var closestDist = Infinity;
          slides.forEach(function (slide, i) {
            var rect = slide.getBoundingClientRect();
            var slideCenter = rect.left + rect.width / 2;
            var dist = Math.abs(slideCenter - center);
            if (dist < closestDist) {
              closestDist = dist;
              closest = i;
            }
          });
          if (closest >= 0 && thumbnails[closest]) {
            setActive(closest);
            if (thumbsContainer && thumbnails[closest].scrollIntoView) {
              thumbnails[closest].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            }
          }
        }, 80);
      }, { passive: true });
    }
  }

  function initSizePicker(section, data) {
    var options = section.querySelectorAll('.oddit-section-product-main__size-option');
    if (!options.length || !data) return;

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        var pos = Number(option.getAttribute('data-option-position'));
        var value = option.getAttribute('data-option-value');
        if (!pos || !value) return;

        var currentId = getCurrentVariantId(section);
        var current = findVariantById(data.variants, currentId);
        if (!current) return;

        var newOptions = current.options.slice();
        newOptions[pos - 1] = value;
        var newVariant = findVariant(data.variants, newOptions);

        if (!newVariant) {
          newVariant = findFirstVariantWithOption(data.variants, pos - 1, value);
        }
        if (!newVariant) return;

        rerenderTiles(section, data, newVariant);
        applyVariant(section, data, newVariant);
      });
    });
  }

  function findFirstVariantWithOption(variants, optionIdx, value) {
    var available = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].options[optionIdx] !== value) continue;
      if (variants[i].available) return variants[i];
      if (!available) available = variants[i];
    }
    return available;
  }

  function initBundleTiers(section, data) {
    if (!data) return;
    bindTileClicks(section, data);
  }

  // Add-to-cart delegation lives in oddit-section-cart-drawer.js (global
  // document-level handler for any [data-add-to-cart][data-variant-id]).
  function initAddToCart() {}
})();
